import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiResponse, IApiList, IImage, IUser, IPagination } from 'src/crud/shared.interface';
import { INotificationPagination } from 'src/stores/notification/interface';
import { IProfileInterest, IInterests } from 'src/stores/profile/interface';
// TODO 
// export interface IRestApiStatus {
//   status: 'success' | 'failure' | 'loading' | 'initial';
//   error?: any;
// }

// TODO

export const axiosInstance = axios.create({ baseURL: process.env.REACT_APP_API_ENDPOINT });
// console.log(process.env.REACT_APP_TENANT)

axiosInstance.interceptors.request.use(request => {
  return request;
}, error => {
  return Promise.reject(error);
});

axiosInstance.interceptors.response.use(response => {
  return response;
}, error => {
  return Promise.reject(error)
})

// SignUp
export const emailConfirmation = async (query: string) => {
  return await axiosInstance.get(`/api/Account/GetActivationInfo${query}`)
};
export const phoneNumberConfirmation = async (value: any) => {
  return await axiosInstance.post(`/api/Account/RequestPhoneNumberTokenForSignUp`, value, { headers: { 'Content-Type': 'application/json' }} )
};
export const certifyPhoneNumberToken = async (value: any) => {
  return await axiosInstance.post(`/api/Account/CertifyPhoneNumberToken`, value, { headers: { 'Content-Type': 'application/json' }} )
};
export const activateUser = async (value: any) => {
  return await axiosInstance.post(`/api/Account/ActivateUser`, value, { headers: { 'Content-Type': 'application/json' }} )
};

// Contract
export const currentContract = async () => {
  return await axiosInstance.get(`api/Contract/current`)
}
export const getContractById = async (id: string) => {
  return await axiosInstance.get(`api/Contract/${id}`);
};
export const getContractList = async () => {
  return await axiosInstance.get(`api/Contract/list`);
};

// Invoice
export const fetchInvoices = async (pagination:IPagination) => {
  return await axiosInstance.get(`api/Invoice/list/`, { params: { ...pagination } })
}
export const fetchInvoiceDetail = async (id: string) => {
  return await axiosInstance.get(`/api/Invoice/${id}`);
};
export const fetchPaymentHistory = async (pagination:IPagination) => {
  return await axiosInstance.get(`/api/Invoice/invoicePaymentsHistory/`, { params: { ...pagination } })
}
export const tokenAuth = async (userNameOrEmailAddress: string, password: string) => {
  return await axiosInstance.post(`/api/TokenAuth/Authenticate`, {userNameOrEmailAddress, password}, { headers: { 'Content-Type': 'application/json' }} )
}
export const refreshTokenAuth = async (refreshToken: string) => {
  return await axiosInstance.post(`/api/TokenAuth/RefreshToken`, null, {
    headers: { 'Content-Type': 'application/json' },
    params: { refreshToken },
  });
}

// ResetPw
export const requestPasswordReset = async (Email: string) => {
  return await axiosInstance.post(`/api/Profile/RequestPasswordReset`, { Email }, { headers: { 'Content-Type': 'application/json' }})
}
export const verifyResetCode = async (Email: string, Code: string) => {
  return await axiosInstance.post(`/api/Profile/VerifyResetCode`, { Email, Code }, { headers: { 'Content-Type': 'application/json' }})
}
export const resetPassword = async (Email: string, Code: string, NewPassword: string) => {
  return await axiosInstance.post(`/api/Profile/ResetPassword`, { Email, Code, NewPassword }, { headers: { 'Content-Type': 'application/json' }})
}

// MySetting
export const getProfile = async () => {
  return await axiosInstance.get(`/api/Profile`)
};
export const changePassword = async (CurrentPassword:string, NewPassword:string) => {
  return await axiosInstance.post(`/api/Profile/ChangePassword`, { CurrentPassword, NewPassword }, { headers: { 'Content-Type': 'application/json' }});
}
export const setVerificationSms = async (PhoneNumber:string, CountryCode:string) => {
  return await axiosInstance.post(`/api/Profile/SendVerificationSms`, { PhoneNumber, CountryCode }, { headers: { 'Content-Type': 'application/json' }})
}
export const verifySmsCode = async (code:string, phoneNumber:string, countryCode:string) => {
  return await axiosInstance.post(`/api/Profile/VerifySmsCode`, { code, phoneNumber, countryCode }, { headers: { 'Content-Type': 'application/json' }})
}
export const sendVerificationEmail = async (Email:string) => {
  return await axiosInstance.post(`/api/Profile/SendVerificationEmail`, { Email }, { headers: { 'Content-Type': 'application/json' }})
}
export const verifyEmailCode = async (Code:string, Email:string) => {
  return await axiosInstance.post(`/api/Profile/VerifyEmailCode`, { Code, Email }, { headers: { 'Content-Type': 'application/json' }})
}
export const updateCashReceiptNumber = async (cashReceiptNumber:string) => {
  return await axiosInstance.post(`/api/Profile/UpdateCashReceiptNumber`, null, {
    headers: { 'Content-Type': 'application/json' },
    params: { cashReceiptNumber }
  })
}

export const setPlayerId = async (PlayerId:string) => {
  return await axiosInstance.post(`/api/Profile/UpdatePlayerId`, { PlayerId }, { headers: { 'Content-Type': 'application/json' }});
}

export const deletePlayerId = async () => {
  const playerId = localStorage.getItem('oneSignalPlayerId');
  if (!playerId) { return; }
  return await axiosInstance.delete(`/api/Profile/DeletePlayerId?playerId=${playerId}`).then(() => {
    localStorage.removeItem('oneSignalPlayerId');
  });
}

// Configuration
export interface IConfigurationResponse {
  timeZone: string;
  currentLanguage: ILanguage;
  languages: ILanguage[];
}

export const enum LanguageType {
  Korean = 'ko',
  English = 'en'
}

export interface ILanguage {
  name: LanguageType;
  displayName: string;
  icon: string;
  isDefault: boolean;
  isDisabled: boolean;
  isRightToLeft: boolean;
}

export const getConfigurations = async () => {
  return await axiosInstance.get<{ result: IConfigurationResponse }>(`/api/configuration`);
};

export const changeCulture = async (cultureName:string) => {
  return await axiosInstance.post(`api/configuration/changeCulture`, null, { 
    headers: { 'Content-Type': 'application/json' },
    params: { cultureName }
  })
};

export const updateAcceptedEmailAd = async (isAcceptedEmailAd:boolean) => {
  return await axiosInstance.put(`api/configuration/updateAcceptedEmailAd`, null, {
    headers: { 'Content-Type': 'application/json' },
    params: { isAcceptedEmailAd }
  })
};

export const updateAcceptedSmsAd = async (isAcceptedSmsAd:boolean) => {
  return await axiosInstance.put(`api/configuration/updateAcceptedSmsAd`, null, {
    headers: { 'Content-Type': 'application/json' },
    params: { isAcceptedSmsAd }
  })
}

export const updateAcceptedPushAd = async (isAcceptedPushAd:boolean) => {
  return await axiosInstance.put(`api/configuration/updateAcceptedPushAd`, null, {
    headers: { 'Content-Type': 'application/json' },
    params: { isAcceptedPushAd }
  })
}

// Profile
export const updateProfile = async (gender:number, birthMonthDay:string, occupation: string, languages: string[], residences: string[], interests: IProfileInterest[]) => {
  const profile = { gender, birthMonthDay, occupation, languages, residences, interests }
  return await axiosInstance.post(`/api/Profile/UpdateProfile`, profile, { headers: { 'Content-Type': 'application/json' }})
};
export const updateResidence = async (residences:string[]) => {
  return await axiosInstance.post(`/api/Profile/UpdateProfile`, {residences}, { headers: { 'Content-Type': 'application/json' }})
};
export const updateUserIntroduction = async (introduction:string) => {
  const introductionJSON = JSON.stringify(introduction)
  return await axiosInstance.post(`/api/Profile/UpdateUserIntroduction`, introductionJSON, { headers: { 'Content-Type': 'application/json' }})
};
export const uploadProfilePicture = async (file: File, fileName:string, fileToken:string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', fileName);
  formData.append('fileToken', fileToken);
  return await axiosInstance.post(`/api/Profile/UploadProfilePicture`, formData, { headers: { 'Content-Type': 'multipart/form-data' }})
};
export const getProfilePicture = async (id:string) => {
  return await axiosInstance.get(`/api/Profile/picture/${id}`) 
};
export const getInterests = async () => {
  return await axiosInstance.get<{ result: IInterests[] }>(`/api/Profile/Interests`)
};

// Notification
export const getNotificationList = async (pagination: INotificationPagination) => {
  return await axiosInstance.get(`/api/notification/list/`, { params: { ...pagination } });
};
export const getNotificationUnread = async () => {
  return await axiosInstance.get(`/api/notification/unreadCount`)
};
export const readAllNotification = async () => {
  return await axiosInstance.post(`/api/notification/readall`)
};

// sso
export const getSsoLoginUrl = async () => {
  return await axiosInstance.get<IApiResponse<any>>(`/api/support/loginurl`)
}

// export const fetchSignInData = async (url: string) => {
//   const instance = axios.create({
//     baseURL: process.env.REACT_APP_API_ENDPOINT,
//     timeout: 5000
//   });

//   axiosInstance.interceptors.request.use(request => {
//     return request;
//   }, error => {
//     return Promise.reject(error);
//   });

//   instance.interceptors.response.use(response => {
//     return response
//   }, error => {
//     return Promise.reject(error)
//   })

//   instance.request(url);
// }


// const Api = async <T>(endpoint: string, opts: AxiosRequestConfig): Promise<T> => {
//   try {
//     // TODO Add Autherization token
//     const xsrfToken = getXsrfToken();
//     const customHeaders: AxiosRequestConfig = {
//       ...opts,
//       headers: {
//         ...opts?.headers ?? {},
//         'Accept': 'application/json',
//         'Content-Type': 'application/json'
//       },
//     }

//     const response: AxiosResponse<T> = await axiosInstance(endpoint, customHeaders);

//     // 정상 리턴인지 체크
//     const responseOK = response && response.status === 200 && response.statusText === 'OK';
//     if (!responseOK) {
//       throw response.data ?? {
//         code: 999,
//         message: `'${response.statusText}' 오류가 발생했습니다.`
//       };
//     }

//     return response.data;

//   } catch (e) {
//     throw e;
//   }
// };

// export default Api;


// WEBPACK FOOTER //
// ./src/modules/api.ts